import { createAsyncThunk } from '@reduxjs/toolkit';

import { loadAllCars } from '@/modules/car/actions/async/loadAllCars';
import { updatePartner } from '@/modules/partner/actions/actions';
import { loadPartnerDocDefinitions } from '@/modules/partner/actions/async/loadDocDefinitions';
import { getPartnerType } from '@/modules/partner/store/selectors';
import type { RootState } from '@/root-store';

import { onboardingAPI } from '../api';
import { namespace } from '../namespace';

const completeOnboarding = createAsyncThunk(
  `${namespace}/complete-onboarding`,
  async (_, { dispatch, getState }) => {
    const partnerType = getPartnerType(getState() as RootState);

    dispatch(loadPartnerDocDefinitions(partnerType));
    dispatch(loadAllCars());

    const onboarding = await onboardingAPI.completeOnboarding();

    await dispatch(updatePartner({ onboarding }));
  },
);

export { completeOnboarding };
